import React from "react";
import Button from '../components/Button';
import ConfirmationDialog from "../components/ConfirmationDialog";
import DataTableView from '../components/DataTableView2';
import SendNotificationModal from "../components/notification/SendNotificationModal";
import { TruncatedText } from '../components/truncated';
import useAnnouncements from '../hooks/logics/operations/use-announcements-dashboard';
import { IGetAllNotificationDocs } from "../utils/types";

const Announcements = () => {
  const {
    notifications,
    totalPages,
    isLoading,
    isDeletingNotification,
    isSendNotificationModalOpen,
    setIsSendNotificationModalOpen,
    app,
    currentPage,
    setCurrentPage,
    selectedNotificationId,
    setSelectedNotificationId,
    handleDeleteNotification,
    handleAppChange,
    refetch,
  } = useAnnouncements();

  const userTypeMap = {
    driver: "Driver",
    user: "User",
    business_user: "Business user",
  };

  console.log("notificationsvalue", notifications)


  const columns = [
    {
      header: "Title",
      className: "md:p-0 md:pl-10",
      accessor: (notification: IGetAllNotificationDocs) => (
        <TruncatedText limit={30} text={notification?.title || "N/A"} className='md:pl-8'
        />
      ),
    },
    {
      header: "Body",
      accessor: (notification: IGetAllNotificationDocs) => (
        <TruncatedText limit={30} text={notification?.body} />
      ),
    },
    {
      header: "Attachment",
      accessor: (notification: IGetAllNotificationDocs) => (
        notification?.image ?
          <a href={`${notification?.image}`} target="_blank" className="text-primary underline cursor-pointer text-primary">View image</a> : "N/A"
      ),
    },
    {
      header: "User type",
      accessor: (notification: IGetAllNotificationDocs) =>
        notification?.userType
          ? userTypeMap[notification?.userType as keyof typeof userTypeMap]
          : "N/A",
    },
    {
      header: "Actions",
      accessor: (notification: IGetAllNotificationDocs) => (
        <Button
          onClick={() => setSelectedNotificationId(notification?._id)}
          variant="outline"
          className="text-red-500 border-none !bg-transparent"
          disabled={notification?._id === selectedNotificationId}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="w-full h-full">
        <div className="pb-2 flex flex-col justify-center font-inter bg-gray-100">
          <div className="flex flex-col md:flex-row justify-between md:justify-end">
            <div className="flex items-center justify-center md:justify-end my-2 md:my-4">
              <div className='flex flex-col md:flex-row-reverse w-full items-center gap-4'>
                <Button
                  onClick={() => setIsSendNotificationModalOpen(true)}
                  className="w-full min-h-0 h-10 md:h-12 md:w-auto md:px-3"
                >
                  Send announcement
                </Button>
                <div className="bg-white flex gap-2 items-center p-2 rounded-full w-full md:w-auto">
                  {["user", "driver", "business_user"].map((type) => (
                    <Button
                      key={type}
                      onClick={() => handleAppChange(type)}
                      className={`${app === type
                        ? "bg-primary text-white"
                        : "bg-transparent text-primary"
                        } rounded-full flex-1 md:w-32 py-2`}
                    >
                      {type === "user"
                        ? "Users"
                        : type === "driver"
                          ? "Drivers"
                          : "Business"}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="md:mt-2">
            <DataTableView
              data={notifications}
              isFetching={isLoading}
              emptyStateMessage="No announcements found"
              columns={columns}
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      </div>

      <ConfirmationDialog
        text="Are you sure you want to delete this notification?"
        isVisible={selectedNotificationId !== ""}
        onHide={() => setSelectedNotificationId("")}
        handleClick={handleDeleteNotification}
        isSubmitButtonDisabled={isDeletingNotification}
      />

      <SendNotificationModal
        onSuccess={refetch}
        isVisible={isSendNotificationModalOpen}
        onHide={() => setIsSendNotificationModalOpen(false)}
      />
    </>
  );
};

export default Announcements;